// extracted by mini-css-extract-plugin
export default {"root":"styles_root__BfqJb","title":"styles_title__cmLZP"};